import { CommonModule } from "@angular/common";
import { NgModule, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { CallToActionComponent } from "@hermes/aphrodite-call-to-action";
import { LogoComponent } from "@hermes/aphrodite-logo";

import { SeparatorComponent } from "@hermes/aphrodite-separator";
import {
    svgCross,
    svgFacebook,
    svgHermesLogo,
    SvgIconComponent,
    svgInstagram,
    svgKakaostory,
    svgLine,
    SvgRegistryService,
    svgTwitter,
    svgWechatAlternate,
    svgWeibo,
    svgX,
    svgYoutube,
} from "@hermes/aphrodite-svg";
import {
    CustomerServiceContactComponent,
    OpeningHoursPipeModule,
} from "@hermes/hermes-web-fragments-customer-service-contact";
import { TrayStateModule } from "@hermes/hermes-web-states-tray-state";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";
import { PhoneNumberPipeModule } from "@hermes/utils-generic-pipes-phone-number";
import { SanitizePipeModule } from "@hermes/utils-generic-pipes-sanitize";

import { FooterColumnsDeprecatedComponent } from "./components/footer-columns-deprecated/footer-columns-deprecated.component";
import { FooterCopyrightDeprecatedComponent } from "./components/footer-copyright-deprecated/footer-copyright-deprecated.component";
import { FooterCountrySelectorButtonDeprecatedComponent } from "./components/footer-country-selector-button-deprecated/footer-country-selector-button-deprecated.component";
import { FooterDeprecatedComponent } from "./components/footer-deprecated/footer-deprecated.component";
import { FooterHereToHelpDeprecatedComponent } from "./components/footer-here-to-help-deprecated/footer-here-to-help-deprecated.component";
import { FooterLegalLinksDeprecatedComponent } from "./components/footer-legal-links-deprecated/footer-legal-links-deprecated.component";
import { FooterLinksGroupDeprecatedComponent } from "./components/footer-links-group-deprecated/footer-links-group-deprecated.component";
import { PrefixWithPipe } from "./components/footer-links-group-deprecated/prefix-with.pipe";
import { FooterNewsletterDeprecatedComponent } from "./components/footer-newsletter-deprecated/footer-newsletter-deprecated.component";
import { FooterSocialNetworksDeprecatedComponent } from "./components/footer-social-networks-deprecated/footer-social-networks.component";

@NgModule({
    imports: [
        CallToActionComponent,
        CommonModule,
        LogoComponent,
        SeparatorComponent,
        OpeningHoursPipeModule,
        PhoneNumberPipeModule,
        TrayStateModule,
        TranslateModule,
        // For FooterLinksGroupComponent
        SanitizePipeModule,
        SrOnlyNoSnippetDirective,
        SvgIconComponent,
        CustomerServiceContactComponent,
        FooterDeprecatedComponent,
        FooterColumnsDeprecatedComponent,
        FooterCopyrightDeprecatedComponent,
        FooterCountrySelectorButtonDeprecatedComponent,
        FooterHereToHelpDeprecatedComponent,
        FooterLegalLinksDeprecatedComponent,
        FooterLinksGroupDeprecatedComponent,
        FooterNewsletterDeprecatedComponent,
        FooterSocialNetworksDeprecatedComponent,
        PrefixWithPipe,
    ],
    exports: [FooterDeprecatedComponent],
})
export class FooterDeprecatedModule {
    constructor() {
        const svgRegistryService = inject(SvgRegistryService);

        svgRegistryService.registerSvgs([
            svgFacebook,
            svgCross,
            svgInstagram,
            svgKakaostory,
            svgTwitter,
            svgX,
            svgWechatAlternate,
            svgWeibo,
            svgYoutube,
            svgLine,
            svgHermesLogo,
        ]);
    }
}
